// store/college/student-management/store/_actionTypes.js

// Fetch Students
export const FETCH_STUDENTS_REQUEST = 'FETCH_STUDENTS_REQUEST';
export const FETCH_STUDENTS_SUCCESS = 'FETCH_STUDENTS_SUCCESS';
export const FETCH_STUDENTS_FAILURE = 'FETCH_STUDENTS_FAILURE';

// Upload Students
export const UPLOAD_STUDENTS_REQUEST = 'UPLOAD_STUDENTS_REQUEST';
export const UPLOAD_STUDENTS_SUCCESS = 'UPLOAD_STUDENTS_SUCCESS';
export const UPLOAD_STUDENTS_FAILURE = 'UPLOAD_STUDENTS_FAILURE';

// Download Template
export const DOWNLOAD_TEMPLATE_REQUEST = 'DOWNLOAD_TEMPLATE_REQUEST';
export const DOWNLOAD_TEMPLATE_SUCCESS = 'DOWNLOAD_TEMPLATE_SUCCESS';
export const DOWNLOAD_TEMPLATE_FAILURE = 'DOWNLOAD_TEMPLATE_FAILURE';

// Create Single Student
export const CREATE_STUDENT_REQUEST = 'CREATE_STUDENT_REQUEST';
export const CREATE_STUDENT_SUCCESS = 'CREATE_STUDENT_SUCCESS';
export const CREATE_STUDENT_FAILURE = 'CREATE_STUDENT_FAILURE';

// Toggle Student Status
export const TOGGLE_STUDENT_STATUS_REQUEST = 'TOGGLE_STUDENT_STATUS_REQUEST';
export const TOGGLE_STUDENT_STATUS_SUCCESS = 'TOGGLE_STUDENT_STATUS_SUCCESS';
export const TOGGLE_STUDENT_STATUS_FAILURE = 'TOGGLE_STUDENT_STATUS_FAILURE';

// Fetch Students Progress
export const FETCH_STUDENTS_PROGRESS_REQUEST = 'FETCH_STUDENTS_PROGRESS_REQUEST';
export const FETCH_STUDENTS_PROGRESS_SUCCESS = 'FETCH_STUDENTS_PROGRESS_SUCCESS';
export const FETCH_STUDENTS_PROGRESS_FAILURE = 'FETCH_STUDENTS_PROGRESS_FAILURE';

// Retry Credentials SMS
export const RETRY_CREDENTIALS_SMS_REQUEST = 'RETRY_CREDENTIALS_SMS_REQUEST';
export const RETRY_CREDENTIALS_SMS_SUCCESS = 'RETRY_CREDENTIALS_SMS_SUCCESS';
export const RETRY_CREDENTIALS_SMS_FAILURE = 'RETRY_CREDENTIALS_SMS_FAILURE';

// Bulk Operations
export const BULK_ENROLL_REQUEST = 'BULK_ENROLL_REQUEST';
export const BULK_ENROLL_SUCCESS = 'BULK_ENROLL_SUCCESS';
export const BULK_ENROLL_FAILURE = 'BULK_ENROLL_FAILURE';

// Search Students
export const SEARCH_STUDENTS_REQUEST = 'SEARCH_STUDENTS_REQUEST';
export const SEARCH_STUDENTS_SUCCESS = 'SEARCH_STUDENTS_SUCCESS';
export const SEARCH_STUDENTS_FAILURE = 'SEARCH_STUDENTS_FAILURE';

// Get Student by ID
export const GET_STUDENT_BY_ID_REQUEST = 'GET_STUDENT_BY_ID_REQUEST';
export const GET_STUDENT_BY_ID_SUCCESS = 'GET_STUDENT_BY_ID_SUCCESS';
export const GET_STUDENT_BY_ID_FAILURE = 'GET_STUDENT_BY_ID_FAILURE';

// Update Student
export const UPDATE_STUDENT_REQUEST = 'UPDATE_STUDENT_REQUEST';
export const UPDATE_STUDENT_SUCCESS = 'UPDATE_STUDENT_SUCCESS';
export const UPDATE_STUDENT_FAILURE = 'UPDATE_STUDENT_FAILURE';

// Delete Student
export const DELETE_STUDENT_REQUEST = 'DELETE_STUDENT_REQUEST';
export const DELETE_STUDENT_SUCCESS = 'DELETE_STUDENT_SUCCESS';
export const DELETE_STUDENT_FAILURE = 'DELETE_STUDENT_FAILURE';

// Get Students by Course
export const GET_STUDENTS_BY_COURSE_REQUEST = 'GET_STUDENTS_BY_COURSE_REQUEST';
export const GET_STUDENTS_BY_COURSE_SUCCESS = 'GET_STUDENTS_BY_COURSE_SUCCESS';
export const GET_STUDENTS_BY_COURSE_FAILURE = 'GET_STUDENTS_BY_COURSE_FAILURE';

// Export Students
export const EXPORT_STUDENTS_REQUEST = 'EXPORT_STUDENTS_REQUEST';
export const EXPORT_STUDENTS_SUCCESS = 'EXPORT_STUDENTS_SUCCESS';
export const EXPORT_STUDENTS_FAILURE = 'EXPORT_STUDENTS_FAILURE';

// Dashboard Statistics
export const GET_DASHBOARD_STATS_REQUEST = 'GET_DASHBOARD_STATS_REQUEST';
export const GET_DASHBOARD_STATS_SUCCESS = 'GET_DASHBOARD_STATS_SUCCESS';
export const GET_DASHBOARD_STATS_FAILURE = 'GET_DASHBOARD_STATS_FAILURE';

// Legacy support
export const BLACKLIST_STUDENT_REQUEST = 'BLACKLIST_STUDENT_REQUEST';
export const BLACKLIST_STUDENT_SUCCESS = 'BLACKLIST_STUDENT_SUCCESS';
export const BLACKLIST_STUDENT_FAILURE = 'BLACKLIST_STUDENT_FAILURE';

// UI State Management
export const SET_SELECTED_STUDENTS = 'SET_SELECTED_STUDENTS';
export const CLEAR_UPLOAD_RESULT = 'CLEAR_UPLOAD_RESULT';
export const SET_FILTERS = 'SET_FILTERS';

export const FETCH_DEGREES_REQUEST = 'FETCH_DEGREES_REQUEST';
export const FETCH_DEGREES_SUCCESS = 'FETCH_DEGREES_SUCCESS';
export const FETCH_DEGREES_FAILURE = 'FETCH_DEGREES_FAILURE';
export  const FETCH_ALL_STUDENTS_WITH_CURRENT_FILTERS_REQUEST = 'FETCH_ALL_STUDENTS_WITH_CURRENT_FILTERS_REQUEST';
export  const FETCH_ALL_STUDENTS_WITH_CURRENT_FILTERS_SUCCESS = 'FETCH_ALL_STUDENTS_WITH_CURRENT_FILTERS_SUCCESS';
export  const FETCH_ALL_STUDENTS_WITH_CURRENT_FILTERS_FAILURE = 'FETCH_ALL_STUDENTS_WITH_CURRENT_FILTERS_FAILURE';
// Degree and Batch Filters
export const SET_DEGREE_FILTER = 'SET_DEGREE_FILTER';
export const SET_BATCH_FILTER = 'SET_BATCH_FILTER';
// Pagination Actions
export const SET_PAGE = 'SET_PAGE';
export const SET_PAGE_SIZE = 'SET_PAGE_SIZE';
export const SET_SEARCH = 'SET_SEARCH';
export const SET_STATUS_FILTER = 'SET_STATUS_FILTER';
export const SET_SORT = 'SET_SORT';
export const SET_SEMESTER_FILTER = 'SET_SEMESTER_FILTER';